export default "__VITE_ASSET__c59f156d__"